module.exports=function(scope){ return `let deviceLicenseKeyIdentifier = "<THIS_IDENTIFIER_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT>"

// Initialize the FaceTec SDK with your SDK Key
// @param - deviceLicenseKeyIdentifier - This is your Device SDK Key Identifier. You can get your Device SDK Key Identifier here: https://dev.facetec.com/zoomsdk/#/account
// @param - initializationSuccessful -  Optional callback to notify caller when FaceTec SDK initialization has completed
//
Zoom.sdk.initialize(
    deviceLicenseKeyIdentifier: deviceLicenseKeyIdentifier,
    completion:
    {
      initializationSuccessful in
          if(!initializationSuccessful) {
            handleUnsuccessfulInit()
            return
          }

          // Ready to launch the User Session!
    }
)
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/ios/00-initialize-dev.swift.tpl